// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentCommitmentHistoryTabQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DevelopmentCommitmentHistoryTabQuery = { __typename?: 'Query', developmentCommitment: { __typename?: 'DevelopmentCommitment', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'] }> } };


export const DevelopmentCommitmentHistoryTabDocument = gql`
    query DevelopmentCommitmentHistoryTab($id: ID!) {
  developmentCommitment(id: $id) {
    id
    history {
      avatar
      title
      subtitle
      recordedAt
    }
  }
}
    `;

/**
 * __useDevelopmentCommitmentHistoryTabQuery__
 *
 * To run a query within a React component, call `useDevelopmentCommitmentHistoryTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentCommitmentHistoryTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentCommitmentHistoryTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDevelopmentCommitmentHistoryTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables> & ({ variables: DevelopmentCommitmentHistoryTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables>(DevelopmentCommitmentHistoryTabDocument, options);
      }
export function useDevelopmentCommitmentHistoryTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables>(DevelopmentCommitmentHistoryTabDocument, options);
        }
// @ts-ignore
export function useDevelopmentCommitmentHistoryTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables>;
export function useDevelopmentCommitmentHistoryTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentCommitmentHistoryTabQuery | undefined, DevelopmentCommitmentHistoryTabQueryVariables>;
export function useDevelopmentCommitmentHistoryTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables>(DevelopmentCommitmentHistoryTabDocument, options);
        }
export type DevelopmentCommitmentHistoryTabQueryHookResult = ReturnType<typeof useDevelopmentCommitmentHistoryTabQuery>;
export type DevelopmentCommitmentHistoryTabLazyQueryHookResult = ReturnType<typeof useDevelopmentCommitmentHistoryTabLazyQuery>;
export type DevelopmentCommitmentHistoryTabSuspenseQueryHookResult = ReturnType<typeof useDevelopmentCommitmentHistoryTabSuspenseQuery>;
export type DevelopmentCommitmentHistoryTabQueryResult = ApolloReactCommon.QueryResult<DevelopmentCommitmentHistoryTabQuery, DevelopmentCommitmentHistoryTabQueryVariables>;